import {CommonAnalyticsActions} from 'constants/AnalyticsConstants';

import {MigrationTab} from '../types/MigrationTab';
import {BaseConfigMigrationEventMetadata, trackCommonEvent} from './CommonConfigMigrationAnalytics';

export type TabNavigationMetadata = BaseConfigMigrationEventMetadata & {
  tab: MigrationTab;
};

export function trackNavigatedConfigMigrationTab(metadata: TabNavigationMetadata): void {
  trackCommonEvent(CommonAnalyticsActions.NAVIGATED_TAB, metadata);
}
